import type {
  GetUserParams,
  GetUserResult,
} from '../../../domain/models/get-user'
import * as types from '../types/get-user-types'

export const getUserRequest = (payload: GetUserParams) => ({
  type: types.GET_USER_REQUEST,
  payload,
})

export const getUserError = (payload: string) => ({
  type: types.GET_USER_ERROR,
  payload,
})

export const getUserSuccess = (payload: GetUserResult) => ({
  type: types.GET_USER_SUCCESS,
  payload,
})

export const getUserReset = () => ({
  type: types.GET_USER_RESET,
})
